<!-- <p>rule-list works!</p> -->
<app-dialog-header headerIcon="rules" headerText="Manage Asset Rules"
    (onCloseClick)="onCancelClick()"></app-dialog-header>
<div class="adjusting-width">
    <nav class="location-title">
        <span>{{ Asset.Name }} - {{ Asset.Description }} Rules: </span>
        <span class="toolbar-spacer"></span>
        <span *ngIf="isAdmin" class="app-icon app-icon--add" (click)="createRule(Asset)" matTooltip="Create New Rule"
            style="float: right;">
            <mat-icon />
        </span>
    </nav>
    <div *ngIf="Rules && Rules.length > 0" style="padding: 1em; width: 100%; max-height: 75vh; overflow-y: auto;">
        <div class=" content-body">
            <ejs-accordion style="border-radius: var(--default-border-radius);">
                <e-accordionitems>
                    <e-accordionitem *ngFor="let rule of Rules as RuleDefinition" [expanded]="false">
                        <ng-template #header>
                            <div class="alignRow ruleheader">
                                <mat-icon *ngIf="rule.Active"
                                    style="margin-right: 0.5em; color: red;">notifications_active</mat-icon>
                                <span>{{ rule.RuleDescription }}</span>
                                <span class="me-auto"></span>
                                <span><small *ngIf="!rule.RuleEnabled">Disabled</small></span>
                            </div>
                        </ng-template>
                        <ng-template #content>
                            <nav>
                                <span style="font-weight: bolder; min-width: 30%;">Rule
                                    Information:</span>
                                <div style="float: right; cursor: pointer; display: flex;">
                                    <span *ngIf="rule.CreatedByUserID" style="margin-right: 3em;">Created
                                        By:
                                        {{rule.CreatedByUserID}}</span>
                                    <span style="margin-right: 3em;">Rule ID: {{rule.RuleID}}</span>
                                    <div style="margin-right: 3em;">
                                        <mat-slide-toggle *ngIf="isAdmin" [checked]="rule.RuleEnabled"
                                            (change)="OnRuleEnable(rule, $event)"
                                            color="primary">Enabled</mat-slide-toggle>
                                    </div>
                                    <span class="app-icon app-icon--edit">
                                        <mat-icon *ngIf="isAdmin" matTooltip="Edit Rule"
                                            (click)="onEditRule(rule, $event)" />
                                    </span>
                                    <span class="app-icon app-icon--delete">
                                        <mat-icon *ngIf="isAdmin" matTooltip="Delete Rule"
                                            (click)="onDeleteRule(rule, $event)" />
                                    </span>
                                    <button mat-raised-button color="primary" class="app-icon--goto"
                                        (click)="goToRule(rule)">
                                        <mat-icon />
                                        <span>Go To Rule</span></button>
                                </div>
                            </nav>

                            <div [ngClass]="{'rule-active': rule.Active}" style="padding: 1em;">
                                <div class="double-column">
                                    <span>Trigger Time:</span>
                                    <span>
                                        <span *ngIf="convertMinutesToHHMM(rule.TriggerTime)[0] != '00'">
                                            {{ convertMinutesToHHMM(rule.TriggerTime)[0] }} Hours and
                                        </span>
                                        <span *ngIf="rule.TriggerTime > 1">{{
                                            convertMinutesToHHMM(rule.TriggerTime)[1] }} Minutes</span>
                                        <span *ngIf="rule.TriggerTime == 1">{{
                                            convertMinutesToHHMM(rule.TriggerTime)[1] }} Minute</span>
                                    </span>
                                </div>
                                <span class="seperator">RULE WILL TRIGGER IF</span>
                                <div class="rule-info-between"
                                    *ngIf="rule.RuleDef && (rule.RuleDef[0].Operator == '~' || rule.RuleDef[0].Operator == '!~')">
                                    <span style="text-decoration: underline;">DataPoint</span>
                                    <span style="text-decoration: underline;">Operator</span>
                                    <span style="text-decoration: underline;">Upper Limit</span>
                                    <span></span>
                                    <span style="text-decoration: underline;">Lower Limit</span>
                                    <div *ngFor="let s of explainRuleDefintion(rule.RuleDef[0]); let i = index">
                                        <div [ngClass]="{'grid-def': ((i+1) % 6) != 0 }">
                                            <span>{{ s }}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="rule-info"
                                    *ngIf="rule.RuleDef && (rule.RuleDef[0].Operator != '~' && rule.RuleDef[0].Operator != '!~')">
                                    <span style="text-decoration: underline;">DataPoint</span>
                                    <span style="text-decoration: underline;">Operator</span>
                                    <span style="text-decoration: underline;">Limit</span>
                                    <div *ngFor="let s of explainRuleDefintion(rule.RuleDef[0]); let i = index">
                                        <div [ngClass]="{'grid-def': ((i+1) % 4) != 0 }">
                                            <span>{{ s }}</span>
                                        </div>
                                    </div>
                                </div>
                                <span class="seperator">{{ getComparison(rule) }}</span>
                                <div class="rule-info-between"
                                    *ngIf="rule.RuleDef && rule.RuleDef[1] && (rule.RuleDef[1].Operator == '~' || rule.RuleDef[1].Operator == '!~')">
                                    <span style="text-decoration: underline;">DataPoint</span>
                                    <span style="text-decoration: underline;">Operator</span>
                                    <span style="text-decoration: underline;">Upper Limit</span>
                                    <span></span>
                                    <span style="text-decoration: underline;">Lower Limit</span>
                                    <div *ngFor="let s of explainRuleDefintion(rule.RuleDef[1]); let i = index">
                                        <div [ngClass]="{'grid-def': ((i+1) % 6) != 0 }">
                                            <span>{{ s }}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="rule-info"
                                    *ngIf="rule.RuleDef && rule.RuleDef[1] && (rule.RuleDef[1].Operator != '~' && rule.RuleDef[1].Operator != '!~')">
                                    <span style="text-decoration: underline;">DataPoint</span>
                                    <span style="text-decoration: underline;">Operator</span>
                                    <span style="text-decoration: underline;">Limit</span>
                                    <div *ngFor="let s of explainRuleDefintion(rule.RuleDef[1]); let i = index">
                                        <div [ngClass]="{'grid-def': ((i+1) % 4) != 0 }">
                                            <span>{{ s }}</span>
                                        </div>
                                    </div>
                                </div>

                                <div class="seperator">
                                    <span>FOR&nbsp;</span>
                                    <span>{{ convertMinutesToHHMM(rule.TriggerTime)[0]
                                        }}:{{
                                        convertMinutesToHHMM(rule.TriggerTime)[1] }}
                                    </span>
                                </div>
                            </div>
                        </ng-template>
                    </e-accordionitem>
                </e-accordionitems>
            </ejs-accordion>
        </div>
    </div>
    <div class="location-title" *ngIf="Rules && Rules.length == 0">
        <span>This Asset Has No Rules</span>
    </div>

    <div mat-dialog-actions>
        <button mat-button (click)="onCancelClick()">Close</button>
    </div>

</div>